<div class="main-content">
  <app-header [title]="'LEGAL_DOCUMENTS_FORM.TITLE' | translate" />
  <div class="row pt-5 mt-4 mt-md-0">
    <div class="col-12">
      @if (!showSuccess && !showError) {
        <app-icam-container [centralIcon]="true" [iconName]="'repository'" [iconColor]="'#e30714'" [iconHeight]="'32px'">
          @if (!isLoading) {
            <div class="legal-document-container">
              <form [formGroup]="form" (ngSubmit)="onSubmit()" class="form-container d-flex flex-column">
                <div class="row">
                  <div class="col-12">
                    <div class="input-wrapper">
                      <span class="form-label">{{ 'LEGAL_DOCUMENTS_FORM.TYPE' | translate }}</span>
                      <p class="fw-semibold">
                        {{ ('LEGAL_DOCUMENTS.TYPES.' + legalDocument?.type) | translate }} ·
                        {{ legalDocument?.lang | uppercase }}
                      </p>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <div class="input-wrapper">
                      <label for="pdf">{{ 'LEGAL_DOCUMENTS_FORM.PDF_LABEL' | translate }}</label>
                      <div class="d-flex align-items-center gap-2">
                        <label for="pdf" class="custom-file-upload" [ngClass]="isLight ? 'light' : 'dark'">
                          <app-icam-icon iconName="attachment" />
                          {{ 'LEGAL_DOCUMENTS_FORM.CHOOSE_FILE' | translate }}
                        </label>
                      </div>
                      <input id="pdf" type="file" style="display: none" (change)="onPdfSelected($event)" accept="application/pdf" />
                      @if (pdf) {
                        <p class="text-muted">
                          {{ pdf.name }}
                          <small
                            class="text-decoration-underline"
                            role="button"
                            (click)="removePdf()"
                            (keydown.enter)="removePdf()"
                            tabindex="0"
                          >
                            ({{ 'COMMON.REMOVE' | translate }})
                          </small>
                        </p>
                      }
                      @if (!pdf && legalDocument?.attachment) {
                        <p class="text-muted">
                          {{ 'LEGAL_DOCUMENTS_FORM.CURRENT_FILE' | translate }}: {{ legalDocument?.attachment?.fileName }}
                        </p>
                      }
                      @if (!pdf && !legalDocument?.attachment) {
                        <p class="text-muted">{{ 'LEGAL_DOCUMENTS_FORM.NO_FILE' | translate }}</p>
                      }
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <div class="input-wrapper">
                      <label for="htmlContent">{{ 'LEGAL_DOCUMENTS_FORM.HTML_CONTENT_LABEL' | translate }}</label>
                      <textarea
                        id="htmlContent"
                        class="form-control"
                        rows="10"
                        formControlName="htmlContent"
                        [placeholder]="'LEGAL_DOCUMENTS_FORM.HTML_CONTENT_PLACEHOLDER' | translate"
                      ></textarea>
                    </div>
                  </div>
                </div>
                <button
                  type="submit"
                  class="button-form-submit"
                  [class.disabled]="isLoading"
                  [disabled]="isLoading"
                >
                  @if (isLoading) {
                    <div class="d-flex justify-content-center">
                      <div class="spinner-border spinner-border-sm" role="status"></div>
                    </div>
                  } @else {
                    {{ 'LEGAL_DOCUMENTS_FORM.SAVE' | translate }}
                  }
                </button>
              </form>
            </div>
          }
          @if (isLoading) {
            <div class="loading-container text-center py-5">
              <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">{{ 'COMMON.LOADING' | translate }}</span>
              </div>
              <p class="mt-3">{{ 'COMMON.LOADING' | translate }}</p>
            </div>
          }
        </app-icam-container>
      }

      @if (saveSuccess) {
        <app-icam-container [centralIcon]="true" [iconName]="'OK'" [iconColor]="'#00A5A9'" [iconHeight]="'60px'">
          <div class="central-content w-100 text-center d-flex flex-column align-items-center">
            <h1 class="success-title mt-4">{{ 'LEGAL_DOCUMENTS_FORM.UPDATED' | translate }}</h1>
            <button class="btn btn-primary mt-3" (click)="goToList()">
              {{ 'COMMON.RETURN_TO_LIST' | translate }}
            </button>
          </div>
        </app-icam-container>
      }

      @if (saveError || loadError) {
        <app-icam-container [centralIcon]="true" [iconName]="'KO'" [iconColor]="'#e30714'" [iconHeight]="'60px'">
          <div class="central-content w-100 text-center d-flex flex-column align-items-center">
            <h1 class="error-title mt-4">
              {{ (loadError ? 'LEGAL_DOCUMENTS_FORM.LOAD_ERROR' : 'LEGAL_DOCUMENTS_FORM.UPDATE_ERROR') | translate }}
            </h1>
            <p class="subtitle my-3">
              {{ (loadError ? 'LEGAL_DOCUMENTS_FORM.LOAD_ERROR_DESCRIPTION' : 'LEGAL_DOCUMENTS_FORM.UPDATE_ERROR_DESCRIPTION') | translate }}
            </p>
            @if (errorMessage) {
              <div class="text-danger validation-errors">
                <p>{{ errorMessage }}</p>
              </div>
            }
            <button class="btn btn-primary" (click)="tryAgain()">
              {{ 'COMMON.TRY_AGAIN' | translate }}
            </button>
            <button class="btn btn-outline-secondary mt-3" (click)="goToList()">
              {{ 'COMMON.RETURN_TO_LIST' | translate }}
            </button>
          </div>
        </app-icam-container>
      }

      @if (!saveSuccess && !saveError && !loadError) {
        <div class="form-footer d-flex justify-content-between mt-4">
          <app-back-button class="app-back-button" [linkText]="'LEGAL_DOCUMENTS_FORM.BACK_TO_LIST'" (click)="goBack()"></app-back-button>
        </div>
      }
    </div>
  </div>
</div>
<app-footer-copyright />
